export default "__VITE_ASSET__Be19u_$q__"